import { DOCTYPES } from '@/constants/doctypes.ts'
import { createDoctypeListDetailRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  detail: routeTokenCacheDetail,
  home: routeTokenCacheHome,
  root: routeTokenCacheRoot,
} = createDoctypeListDetailRoutes({
  detailName: 'token-cache-detail',
  doctype: DOCTYPES.TOKEN_CACHE,
  homeName: 'token-cache',
  path: 'token-cache',
  views: {
    detail: async () =>
      await import('@/components/viewsExternal/settings/email/tokenCache/ViewTokenCache.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/email/ViewEmailSettings.vue'),
  },
})

export { routeTokenCacheDetail, routeTokenCacheHome, routeTokenCacheRoot }
